import { cache } from 'react';
import { unstable_cache } from 'next/cache';

export { cache, unstable_cache };
